import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../util/mobile-detect';
import plugins from '../../../plugins';
import BNNVARAVideoPlayer from '../BNNVARAVideoPlayer/BNNVARAVideoPlayer';
import NPOVideoPlayer from '../NPOVideoPlayer/NPOVideoPlayer';

export const BNNVARA_VIDEO_PLAYER_TYPE = 'video';
export const NPO_VIDEO_PLAYER_TYPE = 'npo';

const MediaPlayer = ({ type, ...playerProps }) => {
  if (type === BNNVARA_VIDEO_PLAYER_TYPE) {
    const {
      source,
      poster,
      title,
      subtitles,
      genres,
      broadcasters,
      mediaId,
      classifications,
    } = playerProps;

    const searchParams = new URLSearchParams(window.location.search);
    const vertical = !!searchParams.get('vertical');

    return (
      <BNNVARAVideoPlayer
        mediaId={mediaId}
        vertical={vertical}
        source={source}
        poster={poster}
        loadingPosterImage="../../assets/placeholder.jpg"
        isMobile={isMobile()}
        title={title}
        subtitles={subtitles}
        broadcasters={broadcasters}
        plugins={plugins}
        genres={genres}
        classifications={classifications}
      />
    );
  }

  if (type === NPO_VIDEO_PLAYER_TYPE) {
    const { embedId, title } = playerProps;

    return <NPOVideoPlayer embedId={embedId} title={title} />;
  }

  return null;
};

MediaPlayer.propTypes = {
  type: PropTypes.oneOf([BNNVARA_VIDEO_PLAYER_TYPE, NPO_VIDEO_PLAYER_TYPE])
    .isRequired,
};

export default MediaPlayer;
